import { Grid, Layout } from "antd";
import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Sidebar from "../Sidebar";
import Header from "../Header";
import classes from "./dashboardLayout.module.css";
import useNotifications from "../../hooks/useNotifications";
import AssistanceModal from "../AssistanceModal";

const { Content } = Layout;

const DashboardLayout = () => {
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const location = useLocation();
  const { fetchNotifications } = useNotifications();

  useEffect(() => {
    fetchNotifications();
  }, [location]);

  return (
    <Layout hasSider={screens.lg}>
      <Sidebar/>
      <Layout>
        <div className={classes.layout}>
          <Header/>
          <Content className={classes.content}>
            <Outlet/>
          </Content>
        </div>
        <AssistanceModal/>
      </Layout>
    </Layout>
  );
};

export default DashboardLayout;
